import Link from 'next/link';
import PropTypes from 'prop-types';

// Styles
import styles from './SiteMapSection.module.css';

function SiteMapSection({ name, link, children }) {
  const TagLink = link ? Link : 'div';

  return (
    <div className={`${styles.container} container`}>
      <div className={styles.section}>
        <TagLink href={link || undefined} className={styles.link}>
          {name}
        </TagLink>
      </div>
      {children}
    </div>
  );
}

SiteMapSection.propTypes = {
  name: PropTypes.string.isRequired,
  link: PropTypes.string,
  children: PropTypes.node,
};
SiteMapSection.defaultProps = {
  link: '',
  children: null,
};

export default SiteMapSection;
